<ion-header *ngIf="model">
  <ion-toolbar [color]="model.mostrar.color">
    <ion-title>{{ model.mostrar.titulo }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="model" class="modal-content">

  <div class="form-scroll-area">
    <ion-grid>
      <ion-row>
        <ion-col *ngFor="let item of sortedComponents" [size]="item.size">

          <ng-container [ngSwitch]="item.__type">

            <!-- Input -->
            <div *ngSwitchCase="'input'" class="input-group">
              <ion-label class="field-label">{{ item.titulo || item.nombre }}</ion-label>
              <div class="modern-item">
                <input [type]="item.type || 'text'" [(ngModel)]="item.value" [readonly]="item.readonly"
                  (input)="onInput(item, $event)" class="native-input" [placeholder]="item.placeholder || ''">
              </div>

              <!-- Suggestions List -->
              <ion-list class="suggestions-list" *ngIf="hasSuggestions(item._uniqueId)">
                <ion-item *ngFor="let s of (filteredSuggestions[item._uniqueId] || [])"
                  (click)="selectSuggestion(item, s)" button class="suggestion-item">
                  <ion-label>{{ s }}</ion-label>
                </ion-item>
              </ion-list>
            </div>

            <!-- Textarea -->
            <div *ngSwitchCase="'textarea'" class="input-group">
              <ion-label class="field-label">{{ item.titulo || item.nombre }}</ion-label>
              <div class="modern-item textarea-item">
                <textarea [placeholder]="item.placeholder || 'Detalle...'" [rows]="item.rows || 3"
                  [(ngModel)]="item.value" [readonly]="item.readonly" class="native-textarea">
                </textarea>
              </div>
            </div>

            <!-- Date -->
            <div *ngSwitchCase="'date'" class="input-group">
              <ion-label class="field-label">{{ item.titulo || item.nombre }}</ion-label>
              <div class="modern-item date-item">
                <input type="date" [(ngModel)]="item.value" class="native-input native-date">
                <ion-icon name="calendar-outline" class="date-icon"></ion-icon>
              </div>
            </div>

            <!-- Select Option -->
            <div *ngSwitchCase="'selectOption'" class="input-group">
              <ion-label class="field-label">{{ item.titulo }}</ion-label>
              <div class="modern-item select-item" (click)="openSelectionModal(item)" button>
                <div class="select-content">
                  <!-- Display Count for Multi-selection (Restored container class for styling) -->
                  <div *ngIf="isArray(item.value) && item.value.length > 0" class="chips-scroll-container">
                    <ion-chip>
                      <ion-label>{{ item.value.length }} Seleccionado(s)</ion-label>
                    </ion-chip>
                  </div>

                  <!-- Display Single Value or Placeholder -->
                  <span *ngIf="!isArray(item.value) || item.value.length === 0" class="select-value"
                    [class.placeholder]="!item.value || item.value.length === 0">
                    {{ getLabel(item) || 'Seleccionar...' }}
                  </span>

                  <ion-icon name="chevron-down-outline" class="select-chevron"></ion-icon>
                </div>
              </div>
            </div>

            <!-- Take Pic Button -->
            <div *ngSwitchCase="'takePic'" class="input-group">
              <!-- Button to take/change pic -->
              <ion-button [color]="item.color" expand="block" shape="round" class="modern-btn"
                (click)="handleTakePic(item)">
                <ion-icon [name]="item.icon" slot="start"></ion-icon>
                {{ item.nombre }} {{ item.imagesBase64?.length ? '(' + item.imagesBase64.length + ')' : '' }}
              </ion-button>

              <!-- Multiple Images Preview with Delete Button -->
              <div *ngIf="item.value === 'Y' && item.imagesBase64 && item.imagesBase64.length > 0"
                class="images-scroll-container">
                <div *ngFor="let img64 of item.imagesBase64; let i = index" class="image-preview-wrapper"
                  (click)="viewImage(img64)">
                  <img [src]="'data:image/jpeg;base64,' + img64" class="preview-img" />
                  <ion-button color="danger" class="remove-pic-btn-mini" (click)="removePic(item, i)">
                    <ion-icon name="close-circle" slot="icon-only"></ion-icon>
                  </ion-button>
                </div>
              </div>
            </div>

            <!-- Toggle -->
            <div *ngSwitchCase="'toggle'" class="input-group">
              <ion-item lines="none" class="modern-item toggle-item" style="--padding-start: 12px; font-size: 0.95rem;">
                <ion-label class="field-label" style="margin-left:0;">{{ item.nombre }}</ion-label>
                <ion-toggle [checked]="item.value" [(ngModel)]="item.value" [color]="item.color || 'primary'"
                  slot="end"></ion-toggle>
              </ion-item>
            </div>

            <!-- Button Modal -->
            <div *ngSwitchCase="'buttonmodal'" class="input-group" style="padding-top: 10px;">
              <ion-button [color]="item.color || 'secondary'" expand="block" shape="round" class="modern-btn"
                (click)="openDynamicModal(item)">
                <ion-icon [name]="item.icon || 'open'" slot="start"></ion-icon>
                {{ item.nombre }} {{ item.value && item.value.details ? '(' + item.value.details.length + ')' : '' }}
              </ion-button>
            </div>

          </ng-container>

        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Buttons -->
    <div class="action-buttons">
      <ion-button *ngFor="let btn of model.components?.button" [color]="btn.color" class="modern-btn"
        (click)="handleAction(btn)">
        {{ btn.nombre }}
      </ion-button>
    </div>
  </div>

</ion-content>
